import { AxiosError, AxiosResponse } from "axios"
import api from "../../../data/api"
import { Dispatch } from "react"
import { prepareError, prepareErrorFromArray } from "../../../utils/error"
import { objectFormData } from "../../../utils/formdata"


import { Security } from "../../../openapi/security/api"
import { SecurityDetailAction } from "../detail/reducer"

// search for Securities
export const fetchSecurityDetail = (
    dispatch: Dispatch<SecurityDetailAction>,
    data: FormData,
    commonCode: string
) => {    
    let inputParameters = objectFormData(data);    
    inputParameters["cmc"] = commonCode;
    
    api 
        .post("/codelist/luxcsd/v1/SecurityDetail/search", inputParameters) 
        .then( (response:AxiosResponse) => {
            if ( response.data.result && response.data.result === "ERROR") {
                dispatch({ type: "Security/FETCHERROR", payload: prepareErrorFromArray(response.data.errorMessage, "Error") })
            } else if ( response.data.result && response.data.result === "REJECTED" ){
                dispatch({ type: "Security/FETCHERROR", payload: prepareErrorFromArray(response.data.errorMessage, "Rejected") })
            } else {                  
                const securities : Security[] = response.data.securityList; 
                if ( securities.length === 0 ) {
                    dispatch({ type: "Security/FETCHERROR", payload: prepareErrorFromArray(["No Results Found"], "Error") })
                } else {                    
                    dispatch({type: "SecurityDetail/SEARCHDONE", payload: securities, searchCriteria: data})
                }
            }
        }).catch( (error:AxiosError) => {
            dispatch({ type: "Security/FETCHERROR", payload: prepareError(error) })           
        })
}
